<nav class="d-flex align-items-center gap-1 p-2">
  <div #overlayMenu class="position-relative" *ngIf="invisiblePathArray.length > 0">
    <mat-icon aria-hidden="true" (click)="showPanel = !showPanel" class="cursor-pointer">more_horiz</mat-icon>

    <div *ngIf="showPanel && invisiblePathArray.length > 0" class="dropdown-menu show">
      <span
        class="cursor-pointer"
        *ngFor="let item of invisiblePathArray"
        (click)="breadcrumbHandler.emit(item.name)"
        >{{ item.name }}</span
      >
    </div>
  </div>
  <ng-container *ngFor="let item of pathArray; let last = last">
    <span *ngIf="item.visible" (click)="breadcrumbClick(item.name, last)" [title]="item.name" class="breadcrumb-path">{{
      item.name
    }}</span>
    <mat-icon *ngIf="!last && item.visible" aria-hidden="true">keyboard_arrow_right</mat-icon>
  </ng-container>
</nav>
